<template>
  <div :class="['cardWrap', 'clearfix','gbCardWrap',companyType == 5?'mapCardWrap':'']">
    <!--  @click="titleHandle" -->
    <div :class="['cardText', 'clearfix',baseData.isClick?'haveBrowsed':'']" :key="`${rendKey}${baseData.hid}`" @click="titleHandle(false)">
      <!-- checkBox -->
      <div class="cardLeft">
        <div class="cardLfTop clearfix">
          <div style="float: left" class="cdfpChecked">
            <slot />
          </div>
          <div class="logoAndStar clearfix">
            <div v-if="baseData.logoPath" class="logo"><img :src="repliceHttps(baseData.logoPath)" alt="" srcset="" @error.once="baseData.logoPath = null"></div>
            <div v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ backgroundColor">{{setLineHeight(baseData.alias)}}</div>
          </div>
          <div class="details">
            <div class="nameWrap mb-10">
              <div class="company-name"><span class="name" v-html="companyNameColor || '--'">
                </span><span class="copy-box"><i class="el-icon-document-copy copy-icon" @click.stop="onCopy(companyNameColor,'a')">复制</i></span>
              </div>
              <el-tag class="tgP tg" size="mini" effect="plain" v-if="baseData.regStatus">{{baseData.regStatus}}</el-tag>
              <div v-if="baseData.unlockType===2" class="playGet font-12">赠</div>
              <div class="star ml-6">
                <div :class="['bg',{'unstar':!baseData.star}]" @click.stop="handleStarB"></div>
              </div>
            </div>
            <div class="bqTag" v-if="companyTags.length">
              <p class="tag-title" :class="`tag-title-${tag.type}`" v-for="(tag,i) in companyTags" :key="i">{{tag.tagName}}</p>
            </div>
            <dl class="text">
              <dd class="mr-10">
                <div class="textOverflow">
                  <span>企业法人: </span> <span v-html="baseData.legalPersonName || '--'"></span>
                </div>
                <div class="textOverflow">
                  <span>企业规模: </span><span>{{staffSize}}</span>
                </div>
              </dd>
              <dd class="mr-10">
                <div class="textOverflow">
                  <span>注册资本: </span>
                  <span v-if="baseData.regCapital">{{Global.formatAmount(baseData.regCapital)}}</span>
                  <span v-else>{{Global.formatAmount(regCapital)}}</span>
                </div>
                <div class="textOverflow">
                  <span>企业网址: </span>
                  <span v-if="companyWeb" @click.stop="setlll(companyWeb)" target="_blank" style="color:#333333;font-size:13px;">{{companyWeb}}</span>
                  <span v-else>--</span>
                </div>
              </dd>
              <dd class="mr-10">
                <div class="textOverflow">
                  <span>成立日期: </span>
                  <span v-if="baseData.establishTime">{{baseData.establishTime | formatTime }}</span>
                  <span v-else>{{baseData.estiblishTime | formatTime }}</span>
                </div>
                <div class="textOverflow">
                  <span>所属行业: </span>
                  <span class="span02" :title="companyIndustry">{{companyIndustry}}</span>
                </div>
              </dd>
              <dd class="mr-10" v-if="subscriptionType">
                <template v-if="subscriptionType == 1">
                  <div class="textOverflow">
                    <span>商机时间: </span>
                    <span v-if="baseData.establishTime">{{baseData.establishTime | formatTime }}</span>
                    <span v-else>{{baseData.estiblishTime | formatTime }}</span>
                  </div>
                  <div class="textOverflow" style="height:17px">
                  </div>
                </template>
                <template v-if="subscriptionType == 2">
                  <div class="textOverflow">
                    <span>商机时间: </span>
                    <span v-if="baseData.icpLastedTime">{{baseData.icpLastedTime | formatTime }}</span>
                    <span v-else>--</span>
                  </div>
                  <div class="textOverflow">
                    <span>新增ICP: </span>
                    <span v-if="icpDomain" @click.stop="setlll(icpDomain)" target="_blank" style="color:#333333;font-size:13px;">{{icpDomain}}</span>
                    <span v-else>--</span>
                  </div>
                </template>
              </dd>
            </dl>
            <div class="address textOverflow">
              <span>注册地址: </span><span v-html="this.address || '--'"></span>
            </div>
            <div :class="['recommend', 'clearfix', {'recommend-noMargin': !xiaoT}]" v-if="showRecommend && baseData.similarValue">
              <div class="tRecommend" v-if="baseData.similarValue">
                <div class="left">
                  <img src="@/assets/gbIcon/xt.svg" alt="" srcset="">
                  <span>
                    小T智
                  </span>
                </div>
                <div class="text2">
                  <span class="textOverflow">
                    {{baseData.similarValue}}
                  </span>
                  <span v-if="baseData.similarity">，相似度：<i>{{(baseData.similarity * 10000 / 100 ).toFixed(2)}}% </i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="companyType == 1">
          <div class="flag-box" v-if="searchType == 0 && baseData.highlightFields && baseData.highlightFields.length>0">
            <template v-for="(item,index) in baseData.highlightFields.slice(0,4)">
              <div class="tm textOverflow" v-if="baseData[item] && conversionZh[item]" :title="removeHtml(unique(baseData[item]))" :key="item + index" @click.stop="goDetail(item)">
                <img v-if="item == 'productName'" src="@/assets/gbIcon/link_icon.svg" alt="" srcset="">{{conversionZh[item]}}：<span v-html="unique(baseData[item])"></span>
              </div>
            </template>
            <el-popover v-if="baseData.highlightFields.length>4" popper-class="more-flag-box" placement="top" width="282" trigger="hover">
              <div class="content">
                <template v-for="(item,index) in baseData.highlightFields.slice(4)">
                  <p class="tm textOverflow" v-if="baseData[item] && conversionZh[item]" :title="removeHtml(unique(baseData[item]))" :key="item + index" @click.stop="goDetail(item)">
                    {{conversionZh[item]}}：<span v-html="unique(baseData[item])"></span>
                  </p>
                </template>
              </div>
              <div class="more-btn" slot="reference">更多</div>
            </el-popover>
          </div>
          <div class="flag-box" v-if="searchType == 1 && baseData.historyName">
            <div class="tm textOverflow" v-if="baseData.historyName" @click.stop="goDetailTab('','')">
              曾用名：<span v-html="unique(baseData.historyName)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 2 && baseData.businessScope">
            <div class="tm textOverflow" @click.stop="goDetailTab(1,1)">
              经营范围：<span v-html="unique(baseData.businessScope)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 3 && baseData.mainProduct">
            <div class="tm textOverflow" @click.stop="goDetailTab(2,4)">
              主营产品：<span v-html="unique(baseData.mainProduct)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 4 && baseData.executives">
            <!-- <div class="tm textOverflow" v-if="baseData.legalPersonName" @click.stop="goDetailTab('','')">
                  法人：<span v-html="unique(baseData.legalPersonName)"></span>
                </div> -->
            <div class="tm textOverflow" v-if="baseData.executives" @click.stop="goDetailTab(1,2)">
              主要人员：<span v-html="unique(baseData.executives)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 5 && baseData.patentName">
            <div class="tm textOverflow" @click.stop="goDetailTab(4,1)">
              专利名称：<span v-html="unique(baseData.patentName)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 6 && baseData.address">
            <div class="tm textOverflow" @click.stop="goDetailTab('','')">
              通讯地址：<span v-html="unique(baseData.address)"></span>
            </div>
          </div>
          <div class="flag-box" v-if="searchType == 7 && baseData.bidKeyWord">
            <div class="tm textOverflow" @click.stop="goDetailTab(5,1)">
              推广关键词：<span v-html="unique(baseData.bidKeyWord)"></span>
            </div>
          </div>
        </template>

      </div>
      <div class="youBtn clearfix">
        <div class="btns">
          <div class="telList" v-if="baseData.unlock">
            <template v-if="baseData.contactListVOS">
              <div class="item clearfix" v-for="(item,index) in getSortPhone(baseData.contactListVOS.slice(0,3))" :key="index">
                <span class="tel" @click.stop="">{{item.content}}
                  <div class="telCopy" v-if="!item.content.includes('*')" @click.stop="onCopy(item.content,'b',index,baseData.hid)">
                    <i class="el-icon-document-copy">复制</i>
                  </div>
                </span>
                <div class="telTag">
                  <i class="tag" style="margin-left:8px" @click.stop="" v-if="item.contactName">{{item.contactName}}</i>
                  <i class="tag" @click.stop="" v-if="item.isKeyContact">关键人</i>
                </div>
              </div>
              <span class="moreTel" v-if="baseData.contactListVOS && baseData.contactListVOS.length>3" @click.stop="lookNumber">查看详情>></span>
            </template>
            <template v-else>
              <p class="noresult">
                <img src="@/assets/noresult.svg" alt="">
                <i>暂无手机号</i>
              </p>
            </template>
          </div>
          <el-button v-else type="dialog-confirm" v-interestExpire size="default" w88 @click.stop="lookNumber">立即解锁</el-button>
        </div>
      </div>
    </div>

    <div class="transform-icon" v-if="baseData.receive">
      <img src="@/assets/zhuanhua.svg">
    </div>
    <!-- 查看号码抽屉 -->
    <ViewNumber ref="vNumber" v-if="drawerShow!==null" :show.sync="drawerShow" :companyStatus="companyStatus" @unlock-change="unlockChange" />
  </div>
</template>
<script>
import { parseTime, debounce, sortKey } from '@/base/global'
import ViewNumber from '@/components/viewNumber'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { star } from '../api/index'
import { uninterested, unlockContacts, testPoint } from '../api/newClueApi'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
import lockNumber from './../mixins/lockNumber.js'
// import { parse } from 'path'
const getPwdPhoneNumFunc = (e, i) => {
  if (i > 2 && i < 7) { return '*' }
  return e
}
export default {
  name: 'companyCard',
  mixins: [lockNumber],
  components: {
    ViewNumber
  },
  props: {
    // 智能推荐栏
    showRecommend: {
      type: Boolean,
      default: true
    },
    // 小T
    xiaoT: {
      type: Boolean,
      default: false
    },
    // 基本数据
    baseData: {
      type: Object,
      default() {
        return {
          base: '上海', // 地区推荐
          name: '小米1',
          legalPersonName: '王川王川', // legalPersonName
          regCapital: '13000万美元', // regCapital
          createTime: '2010-08-25', // createTime
          regStatus: '在业',
          // city: '上海上海上海上海',//
          regLocation: '北京市海淀区西二旗中路33号院6号楼9层019号', // ，
          star: false,
          unlock: false,
          contactCount: {},
        }
      }
    },
    companyType: {
      type: Number
    },
    subscriptionType: {
      type: Number
    },
    searchType: {
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      rendKey: 0,
      drawerShow: null,
      feedBack: ['行业不符合', '地区不符合', '号码质量差', '其他原因'],
      checkList: [],
      visible: false,
      aliasLineHeight: false,
      // bgColor: ['#8ca3cd', "#c8b7d8", '#90cfb7', '#ae98c6', '#8ca3cc', '#e79178', '#adddf3', '#f56c6c', '#5daf34'],
      bgColor: ['#7DB3D9', 'rgb(132,202,176)', '#8CA3CD', '#BC9EDD'],
      companyStatus: {
        companyName: '',
        name: '',
        lockStatus: false,
        contactCount: {}
      },
      NODE_ENV: '',
      windowProductObj: { 'scrmqw': 'SCRM企微', 'scrmzy': 'SCRM专业' },
      tabCardNum: '',//卡片
      smallCardNum: '',//卡片 - 小按钮选项
      companyListflag: false,//是否是从企业列表标签进入详情
      conversionZh: {
        'productName': '产品', 'tmName': '商标', 'patentName': '专利', 'historyName': '曾用名', 'executives': '主要人员',
        'brands': '品牌', 'phoneNumber': '手机号', 'socialCreditCode': '统一信用代码', 'companyName': '公司名', 'shortName': '简介',
        'regAddress': '注册地址', 'registerNum': '注册号', 'address': '通讯地址', 'siteName': '网站名称', 'stockName': '股票简称', 'shareholder': '股东'
      },
      urlParam: [{ name: 'productName', num1: 2, num2: 3 }, { name: 'tmName', num1: 4, num2: 0 }, { name: 'patentName', num1: 4, num2: 1 }, { name: 'historyName', num1: '', num2: '' }, { name: 'executives', num1: 1, num2: 2 }, { name: 'legalPersonName', num1: '', num2: '' },
      { name: 'brands', num1: '', num2: '' }, { name: 'phoneNumber', num1: '', num2: '' }, { name: 'socialCreditCode', num1: '', num2: '' }, { name: 'companyName', num1: '', num2: '' }, { name: 'shortName', num1: '', num2: '' },
      { name: 'regAddress', num1: '', num2: '' }, { name: 'address', num1: '', num2: '' }, { name: 'siteName', num1: '', num2: '' }, { name: 'stockName', num1: '', num2: '' }, { name: 'shareholder', num1: 1, num2: 3 }]
    }
  },
  watch: {
    // 联系方式次数查询之后设置
    'baseData.contactCount': {
      immediate: true,
      handler(val) {
        if (val) {
          this.companyStatus.contactCount = val
        }
      }
    }
  },
  filters: {
    formatTime(val) {
      if (val) {
        if (typeof val === 'string') val = val.replace(/-/ig, '/')
        return parseTime(new Date(val), '{y}-{m}-{d}')
      }
      return '--'
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo,
      clickCompanyArr: state => state.user.clickCompanyArr
    }),
    regCapital() {
      if (this.baseData.amount === -1) {
        return '--'
      }
      if (this.baseData.registeredCapital && this.baseData.registeredCapital !== '0.0' && this.baseData.unit && this.baseData.currency) {
        return this.baseData.registeredCapital + this.baseData.unit + this.baseData.currency
      }
      return '--'
    },
    staffSize() {
      const staffSize = this.baseData.staffSize
      if (staffSize) {
        // if (staffSize.endsWith('人')) return staffSize
        if (staffSize.includes('人')) return staffSize
        return staffSize + '人'
      }
      return '--'
    },
    companyWeb() {
      if (!this.baseData.websiteList) {
        return false
      }
      // 判断有无年报
      let arr = []
      if (this.baseData.websiteAnnualTag) {
        if (this.baseData.websiteList.includes(',')) {
          this.baseData.websiteList.split(',').forEach((v, index) => {
            this.baseData.websiteAnnualTag.split(',').forEach((v1, index1) => {
              if (index == index1) {
                arr.push({ v, v1 })
              }
            })
          })
          sortKey(arr, 'v1')
          return this.companyStatus.websiteList = this.addUrl3W(arr[0]['v'])
        }

      } else {
        if (this.baseData.websiteList.includes(',')) {
          return this.addUrl3W(this.baseData.websiteList.split(',')[0])
        }
      }
      // if (this.baseData.websiteList.includes(',')) {
      //   return this.baseData.websiteList.split(',')[0]
      // }
      return this.addUrl3W(this.baseData.websiteList)
    },
    icpDomain() {
      if (!this.baseData.icpLastDomain) {
        return false
      }
      if (this.baseData.icpLastDomain.includes(',')) {
        return this.baseData.icpLastDomain.split(',')[0]
      }
      return this.baseData.icpLastDomain
    },
    companyNameColor() {
      return this.baseData.name || this.baseData.companyName
    },
    companyName() {
      return this.removeHtml(this.baseData.name || this.baseData.companyName || this.baseData.unlabeledCompanyName)
    },
    companyAddress() {
      return this.removeHtml(this.baseData.regAddress || this.baseData.regLocation)
    },
    legalPersonName() {
      return this.removeHtml(this.baseData.legalPersonName)
    },
    textTitle() {
      if (this.baseData.similarity) {
        return `${this.baseData.similarValue}，相似度：${(this.baseData.similarity * 10000 / 100).toFixed(2)}% `
      }
      return this.baseData.similarValue
    },
    backgroundColor() {
      return this.bgColor[this.baseData.color]
    },
    address() {
      return this.baseData.regAddress || this.baseData.regLocation
    },
    companyIndustry() {
      if (this.baseData.bigIndustry) {
        const { bigIndustry, smallIndustry, thirdName, fourName } = this.baseData
        if (bigIndustry && smallIndustry && thirdName && fourName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}>${fourName}`
        }
        else if (bigIndustry && smallIndustry && thirdName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}`
        }
        else if (bigIndustry && smallIndustry) {
          return `${bigIndustry}>${smallIndustry}`
        }
        else if (bigIndustry) {
          return bigIndustry
        }
        return '--'
      }

      const { industry, subIndustry, thirdName, fourName } = this.baseData
      if (industry && subIndustry && thirdName && fourName) {
        return `${industry}>${subIndustry}>${thirdName}>${fourName}`
      }
      else if (industry && subIndustry && thirdName) {
        return `${industry}>${subIndustry}>${thirdName}`
      }
      else if (industry && subIndustry) {
        return `${industry}>${subIndustry}`
      }
      else if (industry) {
        return industry
      }
      return '--'
    },
    // erp手机号加密
    phoneNum() {
      return item => {
        if ((process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') && item.content && item.isSubmit) {
          const content = JSON.parse(JSON.stringify(item.content))
          return content.split('').map(getPwdPhoneNumFunc).join('')
        } else {
          return item.content
        }
      }
    },
    companyTags() {
      const tags = (this.baseData?.tags?.split(',') || []).map(v => ({ tagName: v, type: 'primary' }))
      const hasPhone = this.baseData?.hasPhone
      if (hasPhone) {
        tags.unshift({ tagName: '有手机号', type: 'danger' })
      }
      return tags
    },
  },
  mounted() {
    $bus.$on('iframe-unlock', this.handleIframeUnlockChange)
    if (this.$route.query.isErp && (this.$route.query.newName == this.companyName)) {
      setTimeout(() => {
        this.titleHandle(true)
        if (this.$route.query.tabCardNum) {
          this.tabCardNum = this.$route.query.tabCardNum
        }
      }, 600)
    }
    this.NODE_ENV = process.env.NODE_ENV
  },
  methods: {
    test() {
      alert(123)
    },
    goDetail(val) {
      let aa = 0
      this.urlParam.forEach(vv => {
        if (vv.name == val) {
          if (vv.num1 == '') {
            aa++
          }
        }
      })
      if (aa != 0) return false
      this.urlParam.forEach(v => {
        if (v.name == val) {
          this.tabCardNum = String(v.num1)
          this.smallCardNum = v.num2
        }
      })
      this.companyListflag = true
      this.titleHandle(true)
    },
    goDetailTab(v1, v2) {
      if (v1) {
        this.tabCardNum = String(v1)
        this.smallCardNum = v2
        this.companyListflag = true
        this.titleHandle(true)
      }
    },
    // 地址增加www
    addUrl3W(str) {
      var newStr = 'http://www.'
      const ipv4AllRegex = /^https?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (ipv4AllRegex.test(str)) {
        return str
      }
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (!str.includes('http://www.') && !str.includes('https://www.')) {
        if (ipv4Regex.test(str)) {
          return 'http://' + str
        }
        newStr = newStr + str.replace('http://', '').replace('https://', '').replace('www.', '')
        return newStr
      } else {
        return str
      }
    },
    // 电话排序
    getSortPhone(list) {
      let arr1 = []
      let arr2 = []
      list.forEach(v => {
        if (v.isKeyContact == 1) {
          arr1.push(v)
        } else {
          arr2.push(v)
        }
      })
      return [...arr1, ...arr2]
    },
    onCopy(row, val, index, hid) {
      let reg = /<[^<>]+>/g
      row = row.replace(reg, '')
      this.$copyText(row).then(() => {
        this.$message.success('复制成功')
      })
      if (val == 'b') {
        // 埋点
        let productName = ''
        if (window[X_PRODUCT]) {
          productName = windowProductObj[window[X_PRODUCT]]
        } else {
          if (window[X_BLOCK]) {
            productName = 'SCRM企微'
          } else {
            if (window[X_HIDE]) {
              productName = 'SCRM专业'
            } else {
              productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
            }
          }
        }
        let paramsM = {
          eventType: 'contact_copy',//事件类型
          productName: productName,//产品线名称
          pageSource: '列表页',
          type: 1,
          contactRank: parseInt(index + 1),
          contactInfo: row,
          hid: hid
        }
        testPoint(paramsM).then(res => {

        }).catch(err => {

        })
      }
    },
    async handleIframeUnlockChange(data) {
      if (!data.name && !data.hid) return
      if (data.name == this.companyName || data.hid === this.baseData.hid) {
        this.baseData.unlock = true
        await this.getContactList?.()
        this.getUnlockContacts?.()
      }
    },
    getrefererType(item) {
      return ['直接访问', '直接入站', '搜索引擎入站', '网站入站'][item]
    },
    lookNumber() {
      this.tabCardNum = ''
      this.smallCardNum = ''
      let dataNum = {
        tabCardNum: this.tabCardNum,
        smallCardNum: this.smallCardNum
      }
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      // HID为空时提示
      if (this.baseData.hid == null || this.baseData.hid == '') {
        this.$message({
          message: '该企业未收录',
          type: 'warning'
        });
        return false
      }
      console.log('PERMISSION_CONFIRM2', this.surplus, this.baseData.unlock)
      if (this.surplus < 1 && !this.baseData.unlock) { // 没有剩余条数则提示
        this.$store.dispatch('PERMISSION_CONFIRM')
      } else {
        this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }

        if (window.__sendIframeMessage({ ...this.companyStatus, isForce: true, ...dataNum })) return
        this.showDrawer()
      }
    },
    goUrl(url) {
      var newurl = ''
      if (url.indexOf('http://www.') == -1 && url.indexOf('https://www.') == -1) {
        newurl = 'http://www.' + url.replace('http://', '').replace('https://').replace('www.')
        return newurl
      } else {
        return url
      }
    },
    setlll(item) {
      let url = this.goUrl(item)
      this.Global.openUrl(url)
    },
    handleStarB: debounce('handleStar', 300),
    repliceHttps(str) {
      if (!str) return
      const urlP = /^http:\/\/.+/
      if (str.match(urlP)) {
        return str.replace('http://', 'https://')
      }
      return str
    },
    // 去重
    unique(str) {
      if (str == null || str == '') return
      return this.simpleUnique(str.split(',')).join()
    },
    // 简单数组去重
    simpleUnique(array) {
      var result = []
      var hash = {}
      for (var i = 0; i < array.length; i++) {
        var key = (typeof array[i]) + array[i]
        if (!hash[key]) {
          result.push(array[i])
          hash[key] = true
        }
      }
      return result
    },
    clicklistF() {
      this.$emit('click-list', this.baseData)
    },
    titleHandle(val) {
      if (!val) {
        this.tabCardNum = ''
        this.smallCardNum = ''
      }
      this.$set(this.baseData, 'isClick', true)
      this.clicklistF()
      this.$store.commit('CLICK_COMPANY_ARR', JSON.parse(localStorage.getItem('clickList')))
      this.rendKey++
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1 && this.baseData.unlock) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      // 当HID为空时
      if (this.baseData.hid == null || this.baseData.hid == '') {
        this.$message({
          message: '该企业未收录',
          type: 'warning'
        });
        return false
      }
      Object.assign(this.companyStatus, this.baseData)
      this.companyStatus.companyName = this.companyName
      this.companyStatus.lockStatus = this.baseData.unlock
      this.companyStatus.regAddress = this.companyAddress
      this.companyStatus.legalPersonName = this.legalPersonName

      // if (window.__sendIframeMessage(this.companyStatus)) return
      let dataNum = {
        tabCardNum: this.tabCardNum,
        smallCardNum: this.smallCardNum
      }
      if (window.__sendIframeMessage({ ...this.companyStatus, ...dataNum })) return
      console.log('PERMISSION_CONFIRM1', this.surplus, this.baseData.unlock)
      if (this.surplus < 1 && !this.baseData.unlock) {
        this.$store.dispatch('PERMISSION_CONFIRM')
        return
      }
      this.showDrawer()
    },
    // changeNews() {
    //   this.$emit('changeNews-handle', this.companyName)
    // },
    changeRecommendList() {
      this.$emit('change-recommendList')
    },
    setLineHeight(val) {
      if (val && val.length > 0) {
        const zm = /^[A-Za-z]+$/g
        if (zm.test(val) && val.length < 4) {
          this.aliasLineHeight = true
        } else if (val.length < 3) {
          this.aliasLineHeight = true
        }
      }
      const zz = /[\u4e00-\u9fa5]/g
      // if (val) return val.substr(0, 4)
      // return this.companyName.match(zz).join('').substr(0, 4)
      if (val) {
        return val.substr(0, 4)
      } else {
        if (this.companyName?.match(zz)) {
          return this.companyName?.match(zz).join('').substr(0, 4)
        } else {
          return this.companyName?.substr(0, 4)
        }
      }

    },
    showDrawer() {
      this.drawerShow = true
    },
    removeHtml(str) {
      if (!str) return
      str = str.replace('<<', '@@@').replace('>>>', '>@1@1@1')
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '').replace('@@@', '<<').replace('@1@1@1', '>>')
    },
    unlockChange() {
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        });
        return false
      }
      // 不刷新显示解锁
      this.baseData.unlock = true
      this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }
      this.getUnlockContacts()
      this.$emit('unlock-change')
    },
    getUnlockContacts() {
      unlockContacts({ hids: [this.baseData.hid] }).then(res => {
        if (res.code == 200) {
          this.baseData.contactListVOS = res.data[this.baseData.hid]
        }
      })
    },
    async handleStar() {
      let type // 1标准资源 2智能推荐
      this.baseData.similarValue ? type = 2 : type = 1
      let collect // 1收藏 0 取消
      this.baseData.star ? collect = 0 : collect = 1
      const res = await star({ collect, type, name: this.companyName, hid: this.baseData.hid, similarValue: this.baseData.similarValue, similarity: this.baseData.similarity })
      if (res.code === 200) {
        if (collect) {
          this.$message.success('收藏成功！')
          this.changeRecommendList()
        } else {
          this.$message.success('取消收藏成功！')
          this.changeRecommendList()
        }
        this.$emit('getStar')
      } else {
        this.$message.success(res.message)
      }

      // if (collect) this.changeRecommendList()
    },
    async uninterested(companyName, reason) {
      await uninterested({ companyName, reason })
      this.$message.success('操作成功')
      this.changeRecommendList()
    }
  },
  beforeDestroy() {
    $bus.$off('iframe-unlock', this.handleIframeUnlockChange)
  }
}
</script>

<style lang="scss" scoped>
.firstTime {
  // margin-left: 70px;
  margin-left: 82px;
  margin-top: 15px;
  // color: #409eff;
  color: #5088ff;
  > span {
    margin-right: 15px;
    font-size: 12px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mainUrl {
    width: 350px;
  }
}
.sureFeedBack {
  background-color: royalblue;
  color: #fff;
  cursor: pointer;
  width: 40px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  &:hover {
    background-color: #4169e1cf;
  }
}

.cardWrap {
  position: relative;
  // padding: 24px 82px 24px 24px;
  padding: 24px 0px 24px 32px;
  border-bottom: 1px solid #f0f2f5;
  transition: all 0.3s, height 0s;
  box-sizing: border-box;
  &:hover {
    position: relative;
    // box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.1);
    background: rgba(207, 222, 255, 0.3);
  }
  .recommend {
    float: initial;
    margin: 16px 0 0;
    .tRecommend {
      display: flex;
      float: left;
      // margin-left: 100px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #ecd4c1;
      color: #b68060;
      // background-image: url("~@/assets/icon/xtb.png");
      background-image: url("~@/assets/gbIcon/xtb0.png");
      background-size: contain;
      background-repeat: no-repeat;
      // padding-left: 92px;
      padding-right: 12px;
      border-radius: 5px;
      // max-width: 68%;
      .left {
        width: 92px;
        font-size: 0;
        > span {
          font-size: 12px;
          vertical-align: top;
          color: #333;
        }
        > img {
          height: 100%;
          margin-left: 10px;
          margin-bottom: 2px;
          width: 16px;
          height: 17px;
        }
      }
      .text2 {
        display: flex;
        align-items: flex-end;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        > span {
          display: inline-block;
          font-size: 12px;
          max-width: 328px;

          &:last-child {
            // width: calc(100% - 115px);
            vertical-align: top;
            color: #333333;
            font-size: 12px;
          }
        }
        span i {
          font-size: 14px;
        }
      }
    }
    .rightBtn {
      float: right;
      text-align: right;
      line-height: 24px;
      span {
        display: inline-block;
        color: #f59a23;
        text-decoration-line: underline;
        cursor: pointer;
        margin: 0 10px;
      }
      span:hover {
        color: #dc8b22;
      }
    }
  }
  .inquiry-content {
    float: initial;
    margin: 10px 0;
    .tRecommend {
      display: flex;
      float: left;
      height: 24px;
      line-height: 24px;
      background-color: #fafafa;
      background-size: contain;
      background-repeat: no-repeat;
      padding-right: 12px;
      border-radius: 5px;
      .left {
        width: 92px;
        font-size: 0;
        background-color: #e9f1ff;
        text-align: center;
        > span {
          font-size: 12px;
          vertical-align: top;
          color: #333;
          color: #4f7afd;
        }
      }
      .text2 {
        display: flex;
        align-items: flex-end;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        > span {
          display: inline-block;
          font-size: 12px;
          max-width: 328px;

          &:last-child {
            // width: calc(100% - 115px);
            vertical-align: top;
          }
        }
        span i {
          font-size: 14px;
        }
      }
    }
  }
  .recommend-noMargin {
    margin: 0;
  }
  // .tm {
  .flag-box {
    margin-top: 8px;
    margin-left: 147px;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    text-align: left;
    color: #666666;
    background: rgba(187, 190, 202, 0.1);
    padding: 0 16px 0 9px;
    box-sizing: border-box;
    border-radius: 4px;
    max-width: calc(100% - 225px);
    display: flex;
    .tm {
      flex: 1;
      position: relative;
      padding-left: 9px;
      box-sizing: border-box;
      &::before {
        content: "";
        width: 1px;
        height: 16px;
        background: rgba(187, 190, 202, 0.5);
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        position: absolute;
      }
      &:nth-of-type(1) {
        padding-left: 0;
        &::before {
          width: 0;
          display: none;
        }
      }
      > img {
        margin-right: 8px;
        position: relative;
        top: -1px;
        width: 15px;
      }
      > span {
        font-size: 13px;
      }
    }
  }

  .logoAndStar {
    // width: 60px;
    width: 58px;
    height: 58px;
    float: left;
    // margin-right: 10px;
    margin-right: 24px;
    .logo {
      float: right;
      width: 60px;
      height: 60px;
      font-size: 0;
      overflow: hidden;
      position: relative;
      > img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .logo2 {
      float: left;
      width: 58px;
      height: 58px;
      // width: 60px;
      // height: 60px;
      padding: 6px;
      background-color: royalblue;
      font-weight: 400;
      color: #fff;
      text-align: center;
      // font-size: 21px;
      font-size: 18px;
      line-height: 24px;
      border-radius: 2px;
      margin-right: 10px;
    }
    .aliasLineHeight {
      line-height: 48px;
      overflow: hidden;
    }
  }
  .details {
    // width: calc(100% - 120px - 70px);
    float: left;
    width: 80%;
    // height: 222px;
    // .logo {
    //   float: left;
    //   width: 60px;
    //   height: 60px;
    //   padding: 6px;
    //   background-color: royalblue;
    //   font-weight: 400;
    //   color: #fff;
    //   text-align: center;
    //   font-size: 21px;
    //   line-height: 24px;
    //   border-radius: 4px;
    //   margin-right: 10px;
    // }
    .aliasLineHeight {
      line-height: 48px;
    }
    .nameWrap {
      height: 22px;
      .name {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        max-width: 76%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        padding-left: 3px;
        padding-right: 3px;
        box-sizing: border-box;
        height: 22px;
      }
      .company-name {
        position: relative;
        .move-copy {
          position: absolute;
          left: -50px;
          // bottom: 0px;
          width: 48px;
          background: transparent;
          border-radius: 2px;
          text-align: center;
          line-height: 20px;
          padding-bottom: 3px;
          opacity: 0;
          transition: all 0.3s;
          i {
            background: #fff1d9;
            font-weight: 400;
            color: #ffa000;
            font-size: 12px;
            display: block;
          }
        }
        &:hover {
          .move-copy {
            opacity: 1;
          }
          // .name{
          //    color: #5088FF;
          //    background: rgba(187,190,202,0.3);
          // }
        }
      }
      /deep/ .el-tag {
        position: relative;
        top: -5px;
        margin-left: 10px;
        font-size: 12px;
      }
      .star {
        display: inline-block;
        width: 20px;
        // height: 20px;
        position: relative;
        margin-top: 1px;
        > div {
          cursor: pointer;
        }
        .bg {
          // background-image: url("~@/assets/industry/star2.png");
          background-image: url("~@/assets/gbIcon/xx.svg");
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          background-size: 100%;
          position: relative;
        }
        .unstar {
          // background-image: url("~@/assets/gbIcon/star.png");
          background-image: url("~@/assets/gbIcon/xxm.svg");
        }
      }
      .playGet {
        display: inline-block;
        margin-left: 10px;
        background-color: #ebb563;
        color: #fff;
        border-radius: 9px;
        padding: 2px 10px;
      }
    }

    .tags {
      span {
        margin-right: 10px;
      }
      .loadingBtn {
        padding: 0px 5px;
        margin-right: 10px;
        line-height: 18px;
        font-size: 12px;
        background-color: #fdf6ec;
        border-color: #faecd8;
        color: #e6a23c;
      }
    }
    span {
      font-size: 12px;
    }
    .text {
      text-align: left;
      dd {
        font-size: 12px;
        display: inline-block;
        margin-right: 30px;
        > div {
          margin-bottom: 12px;
        }
        span:nth-child(2) {
          color: #333;
        }
        &:nth-child(1) {
          min-width: 140px;
          max-width: 280px;
        }
        &:nth-child(2) {
          width: 210px;
        }
        &:nth-child(3) {
          max-width: 355px;
          min-width: 225px;
        }
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
      }
      dt {
        display: inline-block;
        margin: 0 20px;
      }
      span {
        // color: #999;
        color: rgba(51, 51, 51, 0.5);
      }
    }
    .address {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #999;
      span:nth-child(2) {
        color: #333;
      }
    }

    .tag-title {
      height: 24px;
      line-height: 24px;
      background: rgba(80, 136, 255, 0.15);
      border-radius: 2px;
      font-weight: 400;
      color: #5088ff;
      font-size: 12px;
      padding-left: 16px;
      padding-right: 16px;
      box-sizing: border-box;
      margin-right: 8px;
      display: inline-block;
      margin-bottom: 8px;
    }
    .tag-title-danger {
      background: #ffe6e6;
      color: red;
    }
  }

  .cardText {
    position: relative;
    display: flex;
    .btns {
      position: absolute;
      // right: 0;
      top: 50%;
      transform: translateY(-50%);
      .btn-tip {
        margin-top: 12px;
        font-weight: 400;
        border-radius: 2px;
        background: rgba(48, 191, 120, 0.15);
        width: 82px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #30bf78;
        font-size: 12px;
        span {
          padding: 0 2px;
          color: #409eff;
        }
      }
    }
  }
}
.cardWrap {
  .details {
    span {
      font-size: 13px;
      font-weight: 400;
    }
    .text dd > div {
      margin-bottom: 10px;
    }
  }
}
.details {
  .tg {
    border: none;
    height: 20px;
    line-height: 22px;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    // opacity: 0.15;
    display: inline-block;
    padding: 0 16px;
    text-align: center;
    &.tgP {
      &:hover {
        box-shadow: none;
      }
    }
    &.tg1 {
      background: rgba(182, 32, 224, 0.15);
      color: #b620e0;
    }
    &.tg2 {
      background: rgba(80, 136, 255, 0.15);
      color: #5088ff;
    }
    &.tg3,
    &.tgP {
      background: rgba(48, 191, 120, 0.15);
      color: #30bf78;
    }
  }
}

.btns {
  .el-button {
    border-radius: 4px;
  }
  .el-button.is-w88 {
    height: 32px;
    // line-height: 32px;
    padding: 0;
  }
  .small-drawer-btn {
    box-shadow: 0px 6px 10px 0px rgba(76, 188, 154, 0.2);
  }
  .noresult {
    text-align: center;
    i {
      font-weight: 400;
      color: #5c6075;
      line-height: 20px;
      font-size: 14px;
      display: block;
      margin-top: 6px;
    }
  }
}

.cardWrap {
  .cardText {
    &.haveBrowsed {
      .details {
        .name {
          color: #999999;
        }
      }
    }
    .cardLeft {
      width: 79.9%;
      cursor: pointer;
      .cardLfTop {
        display: flex;
      }
    }
  }
}
::v-deep {
  .small-drawer-btn {
    span {
      font-size: 14px;
    }
  }
}

.youBtn {
  // width: 29.018%;
  width: 20.09%;
  .telList {
    cursor: pointer;
    span {
      float: left;
      font-weight: 400;
      color: #5088ff;
      line-height: 20px;
      font-size: 14px;
      transition: all 0.3s;
      &.moreTel {
        margin-bottom: 0;
      }
    }
    .tag {
      background: rgba(48, 191, 120, 0.15);
      border-radius: 2px;
      padding: 0px 8px;
      box-sizing: border-box;
      font-weight: 400;
      color: #30bf78;
      font-size: 12px;
      margin-left: 4px;
      // display: block;
      float: left;
      max-width: 78px;
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .item {
      height: 20px;
      line-height: 20px;
      position: relative;
      margin-bottom: 12px;
      .telTag {
        position: absolute;
        left: 86px;
        // width: 100%;
        width: 160px;
      }
      .telCopy {
        position: absolute;
        width: 48px;
        // height: 20px;
        line-height: 20px;
        border-radius: 2px;
        text-align: center;
        bottom: 0;
        right: -48px;
        margin: auto;
        opacity: 0;
        background: transparent;
        padding-left: 4px;
        i {
          background: #edf3ff;
          font-weight: 400;
          color: #5088ff;
          font-size: 12px;
          display: block;
          line-height: 20px;
          border-radius: 2px;
          &.el-icon-document-copy:before {
            margin-right: 2px;
          }
        }
      }
      .tel {
        &:hover {
          font-size: 18px;
          font-weight: 500;
          color: #5088ff;
          background: rgba(187, 190, 202, 0.3);
          padding: 0 3px;
          box-sizing: border-box;
          .telCopy {
            opacity: 1;
          }
        }
      }
      .tel:hover ~ .telTag {
        display: none;
        left: 0;
      }
      .tel:hover ~ .tag {
        display: none;
        left: 0;
      }
    }
  }
}
.nameWrap {
  span {
    &.copy-box {
      display: inline-block;
      float: left;
      background: transparent;
      padding-left: 3px;
      box-sizing: border-box;
    }
  }
  .copy-icon {
    color: #5088ff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s;
    opacity: 0;
    position: relative;
    display: none;
    padding: 4px 4px;
    box-sizing: border-box;
    background: #edf3ff;
    border-radius: 2px;
    float: left;
    top: 1px;
    &.el-icon-document-copy:before {
      margin-right: 2px;
    }
  }
  .company-name {
    &:hover {
      .name {
        color: #5088ff;
        background: rgba(187, 190, 202, 0.3);
      }
      .copy-icon {
        display: inline-block;
        opacity: 1;
      }
    }
  }
}
.cardWrap.mapCardWrap .details .text dd:nth-child(3) {
  max-width: 197px;
  min-width: 197px;
}
.cardWrap.mapCardWrap .details {
  width: 86%;
}
.transform-icon {
  width: 72px;
  height: 68px;
  position: absolute;
  top: 0;
  right: 0;
}
.cardWrap.mapCardWrap {
  .youBtn {
    width: 24.09%;
    .telList .item .telTag {
      max-width: 150px;
    }
  }
  .cardText .cardLeft {
    width: 75.9%;
  }
  .details .text dd:nth-child(2) {
    width: 160px;
  }
}
.more-btn {
  font-weight: 400;
  color: #5088ff;
  font-size: 13px;
  margin-left: 10px;
}
@media screen and(max-width:1550px) {
  .cardWrap {
    .youBtn {
      width: 24.09%;
      .telList .item .telTag {
        max-width: 150px;
      }
    }
    .cardText .cardLeft {
      width: 75.9%;
    }
    .details .text dd:nth-child(2) {
      width: 160px;
    }
  }
}
@media screen and(max-width:1466px) {
  .cardWrap .details .text dd:nth-child(3) {
    max-width: 262px;
  }
}
@media screen and(max-width:1366px) {
  .cardWrap .details .text dd:nth-child(3) {
    max-width: 204px;
    min-width: 204px;
  }
}
.cdfpChecked {
  height: 58px;
  line-height: 58px;
}
.cardWrap .tm.tmph {
  img {
    margin-right: 0;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.tooltip-item {
  max-width: 800px;
  div {
    max-height: 68px;
    overflow: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
  }
}
.more-flag-box {
  .content {
    p {
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-bottom: 8px;
      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
